import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PoolService = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my pool service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps pool service businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for pool service businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most pool service businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my pool service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like pool service. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Pool Service - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Pool Service CRM", url: "/industries/pool-service" }
  ];

  const industryData = {
    name: 'Pool Service',
    title: 'Build Recurring Route Revenue & Never Miss a Service Window',
    subtitle: 'Automate weekly service scheduling, capture emergency repairs, and build consistent route-based income',
    icon: '🏊',
    challenges: [
      'Hard to build consistent service routes',
      'Clients forget about seasonal openings/closings',
      'Emergency repairs interrupt schedule',
      'Difficult to manage chemical inventory',
      'Weather affects service scheduling'
    ],
    solutions: [
      'Automated route-based scheduling',
      'Seasonal reminder campaigns',
      'Emergency repair call routing',
      'Chemical usage tracking',
      'Weather-based service adjustments'
    ],
    features: [
      'Route optimization system',
      'Automated service reminders',
      'Seasonal opening/closing alerts',
      'Emergency repair booking',
      'Chemical tracking',
      'Water test result logging',
      'Photo documentation',
      'Review automation'
    ],
    results: [
      '85% route density optimization',
      'Never miss seasonal services',
      '40% more emergency repairs',
      '5.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Pool Service UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for pool service businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for pool service UK, pool service business software, pool service customer management, pool service lead generation UK"
        url="/industries/pool-service"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PoolService;